import React from "react";
import { useHistory } from "react-router-dom";
import "../../user/pages/dashboard/dashboard.css";

const GameCodes = () => {
  const history = useHistory();

  const handleCategorySelect = (category) => {
    history.push(`/stats/${category}`);
  };

  return (
    <div className="mainContent">
      <div className="gamelogButton">
        <div className="gamelogItem">
          <div className="featuredMoneyContainer">
            <span className="innerText">Select Game Category</span>
            <div className="dropdownContent">
              <a onClick={() => handleCategorySelect("category1")}>
                Category 1
              </a>
              <a onClick={() => handleCategorySelect("category2")}>
                Category 2
              </a>
              <a onClick={() => handleCategorySelect("category3")}>
                Category 3
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameCodes;
